/* The logic is now encapsulated in the BestSellers web component below.
  No additional code is needed here. */

if (!customElements.get('new-best-sellers')) {
  class BestSellers extends HTMLElement {
    constructor() {
      super();
      this.activeClasses = {
        button: "filter-sellers__item-button--active",
        grid: "new-best-sellers__body-wrapper--active",
      };
      this.subTitle = this.querySelector(".headlines-sellers__subtitle");
      this.filterButtons = this.querySelectorAll(".filter-sellers__item-button");
      this.listCollection = this.querySelectorAll(".new-best-sellers__body-wrapper");
      this.listRecommendations = this.querySelectorAll(".new-best-sellers__body-wrapper[data-url]");
    }

    connectedCallback() {
      this.filterButtons.forEach(button => {
        button.addEventListener("click", this.setActiveCollection.bind(this));
      });

      this.listRecommendations.forEach(list => {
        this.getRecommendationProducts(list, list.dataset.url);
      });
    }

    setActiveCollection(event) {
      const button = event.currentTarget;
      const { dataset: { value }, textContent } = button;

      this.removeSpecialClass(this.filterButtons, this.activeClasses.button);
      this.removeSpecialClass(this.listCollection, this.activeClasses.grid);

      button.classList.add(this.activeClasses.button);

      const selectedCollection =
        this.findCollection(this.listCollection, "data-value", value) || this.listCollection[0];

      selectedCollection?.classList.add(this.activeClasses.grid);
      this.setCorrectSubTitle(this.subTitle, textContent);
    }

    removeSpecialClass(elements, className) {
      elements.forEach(element => element.classList.remove(className));
    }

    findCollection(elements, attributeName, attributeValue) {
      return [...elements].find(element => element.getAttribute(attributeName) === attributeValue);
    }

    setCorrectSubTitle(element, text) {
      if (element && text) {
        element.innerHTML = text;
      }
    }

    async getRecommendationProducts(wrapper, url) {
      try {
        const response = await fetch(url);
        if (!response.ok || !wrapper) return;

        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const inner = html.querySelector('.new-best-sellers__body-wrapper .new-best-sellers__body-inner');

        if (inner) {
          wrapper.querySelector('.new-best-sellers__body-inner').innerHTML = inner.innerHTML;
          wrapper.swiper?.update();
        }
      } catch (e) {
        console.error("Failed to fetch recommendation products:", e);
      }
    }
  }

  customElements.define('new-best-sellers', BestSellers);
}